// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "ef6619a5b8258165c626b24bebe843c43e0b9e59",
  version: "1.131.0",
};
